import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Toolbar,
  Button,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  Typography,
  useTheme,
  Breadcrumbs,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Popover,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "../../assets/sim_card_download.svg";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import RefreshIcon from "@mui/icons-material/Refresh";
import Sidebar from "./SideBar";
import Logo from "../../assets/logo.svg";
// import darklogo from "../../assets/logo-dark.png";
import darklogo from "../../assets/spark_logo_dark.svg";
import LogoWhite from "../../assets/baseVersion/spark_Verastel_light.svg";
import { useAuth, useStorageManager, useTokens } from "../../shared/hooks";
import GlobalFilter from "../GlobalFilter/GlobalFilter";
import { ThemeContext } from "../../ThemeContext";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getBreadCrumbs } from "../../routes/generate_breadcrumbs";
import Loading from "../loader/loading";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import { Accounts } from "../../pages/Account";
import SearchDialog from "../global_search";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import PersonIcon from "@mui/icons-material/Person";
import moment from "moment";
import { RootState } from "../../store/store";
import axiosInstance from "../../axios/axios";
import NotificationSidebar from "../drawer/NotificationSidebar";
import eventEmitter from "../utils/eventEmitter";
import { END_POINTS } from "../../shared";
import useRolePermissions from "../../shared/hooks/useRolePermissions";
import { ROLES_ROUTE } from "../../shared/constants/constant-data";
import { toast } from "react-toastify";
import { setIsBothCloudAndPremAssetUser, setIsOnlyCloudUser, setIsOnlyPremAssetUser } from "../../modules/authentication/login/Login_Details_slice";
import { setScanDetails, setReportDetails } from "../../pages/onPremises/myScan/MyScanTable_Details_slice";
import { sortReportsByCreatedAtDesc } from "../../utils/sortReports";




const drawerWidth = 240;
const globalFilterWidth = 680;
const getDaysDiff = (expiry: string, timezone: string = "UTC") => {
  const today = moment.tz(timezone).startOf("day");
  const expiryDate = moment.tz(expiry, timezone).startOf("day");
  return expiryDate.diff(today, "days");
};

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const { logout } = useAuth();
  const { clearTokens } = useTokens();
  const themeContext = useContext(ThemeContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [openGlbFilter, setGlbFilter] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [alertCount, setAlertCount] = useState(0);
  const [notificationSidebarOpen, setNotificationSidebarOpen] = useState(false);
  const [notificationSidebarTab, setNotificationSidebarTab] = useState<
    "alerts" | "notifications"
  >("alerts");
  const [notificationSidebarRequest, setNotificationSidebarRequest] = useState(0);
  const { isAssetInventory } = useRolePermissions();
  const [apiReportsData, setApiReportsData] = useState<any[]>([]);
  const [isLoadingReports, setIsLoadingReports] = useState(false);

  const [searchParams] = useSearchParams();
  //const typeParam = searchParams.get('type'); // will be "NIST 800-171 r2"
  const [type, setType] = useState("");
  const [profileImage, setProfileImage] = useState<string>("");
  const [configDiffDevices, setConfigDiffDevices] = useState<any[]>([]);
  const [isConfigDiffDevicesLoading, setIsConfigDiffDevicesLoading] = useState(false);
  const downloadedReportIdsRef = useRef<Set<string>>(new Set());
  const reportData = useSelector(
    (state: RootState) => state.MyScanDetails.reportDetails
  );
  const deletedReportId = useSelector((state: RootState) => state.MyScanDetails.deletedReportId)
  console.log(deletedReportId + "deleted report Data")
  console.log("reportData from Redux:", reportData);


  console.log("reportData type:", typeof reportData);
  console.log("reportData has ID:", reportData?.id);



  const fetchReportsData = async () => {
    try {
      setIsLoadingReports(true);
      console.log("Fetching reports data...");
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const response = await axiosInstance.get(`${END_POINTS.REPORT_REQUESTS}?timezone=${timeZone}`);
      console.log("Reports data fetched:", response.data);

      // if (response.data && Array.isArray(response.data)) {
      //   // Get current time and 2 hours ago
      //   const currentTime = new Date();
      //   const twoHoursAgo = new Date(currentTime.getTime() - (2 * 60 * 60 * 1000)); // 2 hours in milliseconds

      //   console.log("Current time:", currentTime.toISOString());
      //   console.log("2 hours ago:", twoHoursAgo.toISOString());

      //   // Filter reports created in the last 2 hours
      //   const recentReports = response.data.filter((report: any) => {
        const rawData = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.results)
          ? response.data.results
          : [];

        if (rawData.length > 0) {
          // Get current time and 2 hours ago
          const currentTime = new Date();
          const twoHoursAgo = new Date(currentTime.getTime() - (2 * 60 * 60 * 1000)); // 2 hours in milliseconds

          console.log("Current time:", currentTime.toISOString());
          console.log("2 hours ago:", twoHoursAgo.toISOString());

          const recentReports = rawData.filter((report: any) => {
          const createdAt = new Date(report.created_at);
          const isWithinLastTwoHours = createdAt >= twoHoursAgo;



          return isWithinLastTwoHours;
        });

        console.log(`Filtered ${recentReports.length} reports from last 2 hours out of ${response.data.length} total reports`);

        // Process the filtered API data to match our UI structure
        const processedData = recentReports.map((report: any, index: number) => ({
          id: report.id,
          custom_report_name: report.custom_report_name, // Since API doesn't have report names, we'll use generic names
          status: report.status_display.toLowerCase(), // "Completed" -> "completed", "Pending" -> "pending" 
          isDownloadable: report.status_display.toLowerCase() === "completed",
          created_at: report.created_at,
          completed_at: report.completed_at,
          user_id: report.user_id,
          report: report.report
        }));

        console.log("Processed reports data (last 2 hours):", processedData);

        // Merge with existing socket data, keeping socket data as priority
        setApiReportsData(prevData => {
          const mergedData = [...processedData];

          // Add any socket data that's not already in the API data
          prevData.forEach(socketReport => {
            // const existsInApi = processedData.some(apiReport => apiReport.id === socketReport.id);
            const existsInApi = processedData.some((apiReport: any) => apiReport.id === socketReport.id);
            if (!existsInApi) {
              mergedData.unshift(socketReport); // Add socket data to top
            }
          });

          console.log("Merged API and socket data:", mergedData);
          return sortReportsByCreatedAtDesc(mergedData);
        });
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      // toast.error("Failed to fetch reports data");
    } finally {
      setIsLoadingReports(false);
    }
  };

  useEffect(() => {
    fetchReportsData();
  }, []);

  useEffect(() => {
    console.log("useEffect triggered - reportData changed:", reportData);

    const updateScanData = async () => {
      console.log("updateScanData called with reportData:", reportData);

      if (reportData && reportData.id && reportData.custom_report_name && reportData.custom_report_name !== null) {
        console.log("Processing report data with ID:", reportData.id);

        // Transform the socket data to match the API data structure
        const transformedReportData: any = {
          id: reportData.id,
          custom_report_name: reportData.custom_report_name,
          status: reportData.status_display ? reportData.status_display.toLowerCase() : (reportData.status || 'pending'),
          isDownloadable: reportData.status_display ? reportData.status_display.toLowerCase() === "completed" : (reportData.status === 'completed'),
          user_id: reportData.user_id,
          report: reportData.report
        };

        if (reportData.created_at) {
          transformedReportData.created_at = reportData.created_at;
        }
        if (reportData.completed_at) {
          transformedReportData.completed_at = reportData.completed_at;
        }

        console.log("Transformed report data:", transformedReportData);
        // --- AUTO-DOWNLOAD LOGIC ---
        const isCompleted = reportData.status_display?.toLowerCase() === "completed" || reportData.status?.toLowerCase() === "completed";
        if (
          reportData.is_download === true &&
          isCompleted &&
          !downloadedReportIdsRef.current.has(reportData.id)
        ) {
          downloadedReportIdsRef.current.add(reportData.id);
          console.log("Auto-download triggered for report:", reportData.id);
          handleReportDownload(transformedReportData);
          dispatch(setReportDetails({ ...reportData, is_download: false }));
        }
        // ---------------------------

        setApiReportsData(prevData => {
          console.log("Current apiReportsData before update:", prevData);

          // Check if object with this id already exists
          const existingIndex = prevData.findIndex(item => item.id === transformedReportData.id);

          let updatedData: any[];
          if (existingIndex !== -1) {
            // Update existing object with all fields from transformedReportData
            updatedData = [...prevData];
            updatedData[existingIndex] = { ...updatedData[existingIndex], ...transformedReportData };
            console.log("Updated existing report in apiReportsData at index", existingIndex, ":", updatedData[existingIndex]);
          } else {
            // Add new object
            const newReport = { ...transformedReportData };
            if (!newReport.created_at) {
              newReport.created_at = new Date().toISOString();
            }
            updatedData = [newReport, ...prevData];
            console.log("Added new report to apiReportsData:", newReport);
          }
          return sortReportsByCreatedAtDesc(updatedData);
        });
      } else {
        console.log("No reportData or missing ID, skipping update");
      }
    };

    updateScanData();
  }, [reportData]);



  // Popover data arrays
  const tableHeaders = [
    { key: "custom_report_name", label: "Report Name", flex: 2 },
    { key: "status", label: "Status", flex: 1, align: "center" },
    // {
    //   key: "timeToGenerate",
    //   label: "Time to generate",
    //   flex: 1,
    //   align: "center",
    // },
    { key: "action", label: "Action", flex: 1, align: "center" },
  ];



  useEffect(() => {
    if (!deletedReportId) {
      return;
    }

    setApiReportsData((prevData) => {
      if (!Array.isArray(prevData) || prevData.length === 0) {
        return prevData;
      }

      const updatedData = prevData.filter((report) => report?.id !== deletedReportId);

      if (updatedData.length !== prevData.length) {
        console.log(`Removed report with id ${deletedReportId} from apiReportsData`);
      } else {
        console.log(`No report found with id ${deletedReportId} to remove`);
      }

      return sortReportsByCreatedAtDesc(updatedData);
    });
  }, [deletedReportId]);



  // Helper function to calculate duration between created and completed times
  const calculateDuration = (startTime: string, endTime: string) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffMs = end.getTime() - start.getTime();

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const toggleGlobalFilter = () => {
    setGlbFilter((prev) => !prev);
  };
  const scheduleList = useSelector((state: any) => state.ScheduleList);
  const MyScanDetails = useSelector((root: any) => root.MyScanDetails);
  console.log("MyScanDetails", MyScanDetails);
  // const userDetail = useSelector((root: any) => root.UserLoginDetails)
  const global_filter = useSelector(
    (state: any) => state.UserLoginDetails.global_filter
  );

  const Timeout = useSelector((state: any) => state.idleTimeout.timeout);

  console.log(Timeout);
  const { getFromLocalStorage } = useStorageManager();
  const getAssets: any = useSelector(
    (state: RootState) => state.auth.assetsData
  );
  const tempAssetName = useSelector(
    (state: RootState) => state.auth.tempAssetName
  );
  console.log("tempAssetName", tempAssetName);
  const eventManager = useSelector((state: RootState) => state.eventManager);
  const { hasPermissions } = useRolePermissions();
  console.log("eventManager", eventManager);
  useEffect(() => {
    if (location.pathname.includes("compliance-dashboard")) {
      const typeParam = searchParams.get("type");
      if (typeParam) {
        setType(typeParam);
      } else {
        setType(""); // Reset type if no type param
      }
    } else {
      setType(""); // Reset type if not on compliance-dashboard
    }
  }, [location, searchParams]);

  useEffect(() => {
    fetchNotificationCounts();
  }, [eventManager]);

  useEffect(() => {
    console.log("refreshin");
    const navEntries = performance.getEntriesByType("navigation");
    const navType = (navEntries[0] as PerformanceNavigationTiming | undefined)
      ?.type;

    if (navType === "reload") {
      console.log("Page was manually refreshed");
      if (Timeout) {
        logout();
      }
      // Call your logic here
    }
  }, []);

  //const userDetails:any = getFromLocalStorage("userDetails");
  const scheduleEdit = location.pathname.match(
    /^\/onprem\/schedule\/([^\/]+)$/
  );
  const scanDetails = location.pathname.match(/^\/onprem\/scan\/([^\/]+)$/);
  const cloudDetails = location.pathname.match(/^\/cloud\/scan\/([^\/]+)$/);
  const scanDetailsInformation = location.pathname.match(
    /^\/on-premises\/scan-details\/([^\/]+)$/
  );
  const discoverySecurityMatch = location.pathname.match(
    /^\/on-premises\/discovery-security\/([^\/]+)$/
  );
  const discoverySecurityTab = discoverySecurityMatch
    ? searchParams.get("tab") === "discovery"
      ? "discovery"
      : "security"
    : null;
  const showDiscoverySecurityDropdown =
    !!discoverySecurityMatch && discoverySecurityTab === "security";
  const showDiscoverySecurityTitle =
    !!discoverySecurityMatch && discoverySecurityTab === "discovery";
  const assetsDetails = location.pathname.match(
    /^\/on-premises\/new-assets\/([^\/]+)$/
  );

  const [isActionClicked, setIsActionClicked] = useState(false);
  const [userDetails, setUserDetails] = useState<any>({});
  const [days, setDays] = useState<number>(0);
  const [matchBrowser, setMatchBrowser] = useState(false);

  const fetchNotificationCounts = async () => {
    try {
      const response = await axiosInstance.get(
        "/events-notifications/bell-notification-count"
      );
      if (response.data.status === 200) {
        setNotificationCount(response.data.data.NOTIFICATION.count);
        setAlertCount(response.data.data.ALERT.count);
      }
    } catch (error) {
      toast.error("Error fetching notification counts");
    }
  };

  const fetchProfileImage = async () => {
    try {
      const response = await axiosInstance.get(
        END_POINTS.DASHBOARD_PROFILE_IMAGE,
        {
          params: { height: 28, width: 28 },
          responseType: "blob",
        }
      );
      if (response.status === 200 && response.data) {
        const imageUrl = URL.createObjectURL(response.data);
        setProfileImage(imageUrl);
      }
    } catch (error) {
      console.error("Error fetching profile image:", error);
    }
  };

  useEffect(() => {
    const data = JSON.parse(getFromLocalStorage("userDetails") || "{}");
    setUserDetails(data);

    const daysDiff: any = getDaysDiff(data.expiry_date, data.timezone || "UTC");
    setDays(daysDiff);
    fetchNotificationCounts();
    fetchProfileImage();
  }, []);

  useEffect(() => {
    const handleLoginSuccess = () => {
      fetchNotificationCounts();
    };

    const handleOpenSidebar = (event: Event) => {
      eventEmitter.emit("closeAllDrawers");
      const detail = (
        event as CustomEvent<{
          tab?: "alerts" | "notifications";
          path?: string;
        }>
      ).detail;
      if (detail?.tab) {
        setNotificationSidebarTab(detail.tab);
      }
      if (detail?.path && location.pathname !== detail.path) {
        navigate(detail.path);
      }
      setNotificationSidebarRequest((request) => request + 1);
      fetchNotificationCounts();
      setNotificationSidebarOpen(true);
    };

    window.addEventListener("loginSuccess", handleLoginSuccess);
    window.addEventListener("open-notification-sidebar", handleOpenSidebar);

    return () => {
      window.removeEventListener("loginSuccess", handleLoginSuccess);
      window.removeEventListener("open-notification-sidebar", handleOpenSidebar);
    };
  }, []);

  useEffect(() => {
    if (matchBrowser) {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
        if (themeContext?.darkMode !== e.matches) {
          themeContext?.toggleTheme();
        }
      };

      handleChange(mediaQuery); // Initial check
      mediaQuery.addEventListener("change", handleChange);

      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [matchBrowser, themeContext]);

  const breadcrumbs = useMemo(() => {
    return getBreadCrumbs(location.pathname, navigate, type, location.search).map(
      (breadcrumb) => ({
        ...breadcrumb,
        style: {
          fontWeight: "bold",
          fontSize: "20px",
          display: "flex",
          alignItems: "center",
          marginLeft: "15px",
        },
        type,
      })
    );
  }, [location.pathname, navigate, type, location.search]);

  const fetchScans = async () => {
    let url = "";

    if (scanDetails || scanDetailsInformation || discoverySecurityMatch) {
      url = END_POINTS.MY_SCAN_V2;
    } else if (cloudDetails) {
      url = END_POINTS.CLOUD_SCANS;
    }

    if (url) {
      try {
        const payload = {
          timezone: "Asia/Calcutta",
          filter_sched: [],
          search: "",
        };
        const response = await axiosInstance.post(url, payload);
        if (response.data?.data) {
          const scanDetailsList = response.data.data.map((scan: any) => ({
            scan_uuid: scan.scan_uuid,
            onprem_posture_id: scan.onprem_posture_id,
            name: scan.scanname || scan.scan_name || scan.name || "",
            scanType: scan.type || scan.scan_type || "",
          }));
          dispatch(setScanDetails(scanDetailsList));
        }
      } catch (error) {
        console.error("Error fetching scans:", error);
      }
    }
  };

  useEffect(() => {
    const isOnPremScanRoute = /^\/onprem\/scan\/([^\/]+)$/.test(location.pathname);
    const isCloudScanRoute = /^\/cloud\/scan\/([^\/]+)$/.test(location.pathname);
    const isScanDetailsRoute = /^\/on-premises\/scan-details\/([^\/]+)$/.test(location.pathname);
    const isDiscoverySecurityRoute = /^\/on-premises\/discovery-security\/([^\/]+)$/.test(location.pathname);

    if (isOnPremScanRoute || isCloudScanRoute || isScanDetailsRoute || isDiscoverySecurityRoute) {
      fetchScans();
    }
  }, [location.pathname]);


  const handleSelectChange = (selectedValue: string) => {
    navigate(`/onprem/schedule/${selectedValue}`);
  };
  const handleScanChange = (selectedValue: string) => {
    if (scanDetails) {
      navigate(`/onprem/scan/${selectedValue}`);
    } else if (showDiscoverySecurityDropdown) {
      navigate(`/on-premises/discovery-security/${selectedValue}?tab=security`);
    } else {
      navigate(`/cloud/scan/${selectedValue}`);
    }
  };

  const handleScanDetailsChange = (selectedValue: string) => {
    navigate(`/on-premises/scan-details/${selectedValue}`);
  };

  const handleAssetsChange = (selectedValue: string) => {
    const selectedAsset = getAssets.find(
      (asset: any) => asset.device_name === selectedValue
    );
    const assetId = selectedAsset?.device_id;
    navigate(`/on-premises/new-assets/${assetId}`);
  };

  const fetchConfigDiffDevices = async () => {
    try {
      setIsConfigDiffDevicesLoading(true);
      const response = await axiosInstance.post(END_POINTS.DEVICE_LIST);
      const data = response?.data?.data;
      console.log(response, "assetress");

      let list = [];
      if (Array.isArray(data?.device_list)) {
        list = data.device_list;
      } else if (Array.isArray(data)) {
        list = data;
      }
      setConfigDiffDevices(list);
    } catch (error) {
      console.error("Error fetching config diff devices:", error);
    } finally {
      setIsConfigDiffDevicesLoading(false);
    }
  };

  const locationState = location.state as { device_id?: string } | null;
  const isConfigDiffFocused = location.pathname.includes("/on-premises/configdiff") && !!locationState?.device_id;
  useEffect(() => {
    if (isConfigDiffFocused) {
      fetchConfigDiffDevices();
    }
  }, [isConfigDiffFocused]);

  const handleConfigDiffDeviceChange = (deviceId: string) => {
    navigate("/on-premises/configdiff", {
      state: { ...locationState, device_id: deviceId }
    });
  };

  const renderConfigDiffDeviceDropdown = () => {
    if (!isConfigDiffFocused) return null;

    return (
      <div style={{ display: "flex", flexDirection: "row", gap: 15, alignItems: "center" }}>
        <ArrowBackIcon
          sx={{ marginLeft: 3, cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
          <Select
            value={locationState?.device_id || ""}
            onChange={(e) => handleConfigDiffDeviceChange(e.target.value)}
            variant="standard"
            MenuProps={{
              PaperProps: {
                className: "scroll",
                style: { maxHeight: 400, overflowY: "auto" },
              },
            }}
          >
            {configDiffDevices
              .filter((device: any) => device.device_type !== "endpoint" && device.status == 3)
              .map((device: any) => (
                <MenuItem key={device.id || device.device_id} value={device.id || device.device_id}>
                  {device.device_name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const rendreScanDetailsInformtaion = () => {
    if (scanDetailsInformation) {
      console.log("MyScanDetails.scan_uuid", MyScanDetails.scan_uuid);
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
          <ArrowBackIcon
            sx={{ marginLeft: 3, cursor: "pointer" }}
            onClick={() => navigate("/on-premises/scans")}
          />
          <FormControl fullWidth size="small">
            <Select
              defaultValue=""
              value={scanDetailsInformation[1] || MyScanDetails.scan_uuid || ""}
              onChange={(e) => handleScanDetailsChange(e.target.value)}
              variant="standard"
              MenuProps={{
                PaperProps: {
                  className: "scroll",
                  style: { maxHeight: 400, overflowY: "auto" },
                },
              }}
            >
              {MyScanDetails.ScanDetails.map((schedule: any) => (
                <MenuItem
                  key={schedule.scan_uuid || schedule.scan_id || schedule.id}
                  value={schedule.scan_uuid || schedule.scan_id || schedule.id}
                >
                  {schedule.name || schedule.scanname || schedule.scan_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }
    return null;
  };
  const renderScheduleDropdown = () => {
    if (location.pathname.match(/^\/onprem\/schedule\/([^\/]+)$/)) {
      // If the path is /onprem/schedule/{scan_uuid}, render the dropdown
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
          <ArrowBackIcon
            sx={{ marginLeft: 3, cursor: "pointer" }}
            onClick={() => navigate("/on-premises/scans?switch=on")}
          />
          <FormControl fullWidth size="small">
            {/* <InputLabel>Schedule Name</InputLabel> */}
            <Select
              defaultValue=""
              // label="Schedule Name"
              value={
                scheduleList.schedule_scan_id
                  ? scheduleList.schedule_scan_id
                  : ""
              }
              onChange={(e) => handleSelectChange(e.target.value)} // Handle selection change
              variant="standard"
              MenuProps={{
                PaperProps: {
                  className: "scroll",
                  style: { maxHeight: 400, overflowY: "auto" },
                },
              }}
            >
              {scheduleList.schedulelist.map((schedule: any) => (
                <MenuItem
                  key={schedule.schedule_scan_id}
                  value={schedule.schedule_scan_id}
                >
                  {schedule.schedule_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }
    return null;
  };
  const selectedScanValue = useMemo(() => {
    const urlId = scanDetails?.[1] || discoverySecurityMatch?.[1] || cloudDetails?.[1] || MyScanDetails.scan_uuid || "";
    if (!urlId) return "";
    
    // Find matching scan
    const matchedScan = MyScanDetails.ScanDetails.find((s: any) => 
      String(s.onprem_posture_id) === String(urlId) || 
      String(s.scan_uuid) === String(urlId) ||
      String(s.scan_id) === String(urlId) ||
      String(s.id) === String(urlId)
    );
    
    if (matchedScan) {
      return matchedScan.scan_uuid || matchedScan.scan_id || matchedScan.id || "";
    }
    return urlId;
  }, [scanDetails, discoverySecurityMatch, cloudDetails, MyScanDetails.scan_uuid, MyScanDetails.ScanDetails]);

  const renderScansDropdown = () => {
    if (location.pathname.match(/^\/onprem\/scan\/([^\/]+)$/) || cloudDetails || showDiscoverySecurityDropdown) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
          <ArrowBackIcon
            sx={{ marginLeft: 3, cursor: "pointer" }}
            onClick={
              () => {
                if (scanDetails || showDiscoverySecurityDropdown) {
                  navigate("/on-premises/scans");
                } else {
                  navigate("/cloud/scans");
                }
              }
              //navigate("/on-premises/scans")
            }
          />
          <FormControl fullWidth size="small">
            <Select
              defaultValue=""
              value={selectedScanValue}
              onChange={(e) => handleScanChange(e.target.value)}
              variant="standard"
              MenuProps={{
                PaperProps: {
                  className: "scroll",
                  style: { maxHeight: 400, overflowY: "auto" },
                },
              }}
            >
              {MyScanDetails.ScanDetails.map((schedule: any) => (
                <MenuItem
                  key={schedule.scan_uuid || schedule.scan_id || schedule.id}
                  value={schedule.scan_uuid || schedule.scan_id || schedule.id}
                >
                  {schedule.name || schedule.scanname || schedule.scan_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }
    return null;
  };

  const renderDiscoverySecurityTitle = () => {
    if (!showDiscoverySecurityTitle) return null;

    return (
      <div style={{ display: "flex", flexDirection: "row", gap: 15, alignItems: "center" }}>
        <ArrowBackIcon
          sx={{ marginLeft: 3, cursor: "pointer" }}
          onClick={() => navigate("/on-premises/scans")}
        />
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            color: "text.primary",
          }}
          variant="h6"
          component="div"
        >
          Asset Inventory
        </Typography>
      </div>
    );
  };
  const [assetName, setAssetName] = useState<any>(tempAssetName);

  useEffect(() => {
    console.log("tempAssetName", tempAssetName);
    setAssetName(tempAssetName);
  }, [tempAssetName]);

  const renderAssetsDropdown = () => {
    if (location.pathname.match(/^\/on-premises\/new-assets\/([^\/]+)$/)) {
      return (
        <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
          <ArrowBackIcon
            sx={{ marginLeft: 3, cursor: "pointer" }}
            onClick={() => navigate("/on-premises/assets")}
          />
          <FormControl fullWidth size="small">
            <Select
              defaultValue=""
              value={assetName || ""}
              onChange={(e) => {
                handleAssetsChange(e.target.value);
                setAssetName(e.target.value);
              }}
              variant="standard"
              MenuProps={{
                PaperProps: {
                  className: "scroll",
                  style: { maxHeight: 400, overflowY: "auto" },
                },
              }}
            >
              {getAssets?.map((assets: any) => (
                <MenuItem key={assets.device_name} value={assets.device_name}>
                  {assets.device_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }
    return null;
  };

  // const rendreScanDetailsInformtaion = () => {
  //   if (location.pathname.match(/^\/onprem\/scan-details\/([^\/]+)$/)) {
  //     return (
  //       <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
  //         <ArrowBackIcon
  //           sx={{ marginLeft: 3, cursor: "pointer" }}
  //           onClick={() => navigate("/on-premises/scans")}
  //         />
  //         <FormControl fullWidth size="small">
  //           <Select
  //             defaultValue=""
  //             value={MyScanDetails.scan_uuid || ""}
  //             onChange={(e) => handleScanChange(e.target.value)}
  //             variant="standard"
  //           >
  //             {MyScanDetails.ScanDetails.map((schedule: any) => (
  //               <MenuItem key={schedule.scan_uuid} value={schedule.scan_uuid}>
  //                 {schedule.name}
  //               </MenuItem>
  //             ))}
  //           </Select>

  //         </FormControl>
  //       </div>
  //     );
  //   }
  //   return null;
  // };

  const toggleDrawer = () => {
    setOpen((prev) => !prev);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = async () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    clearTokens();
    // dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
    // dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
    // dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
    navigate("/login");
    // store.dispatch(authActions.logout());
    // window.location.href = "/login";
  };

  const handleBreadcrumbClick = () => { };

  const handleAccount = () => {
    setAnchorEl(null); // Close the menu
    setIsActionClicked(true); // Open the right-side drawer
    handleMenuClose();
  };
  // useEffect(() => {
  //   return () => {
  //     if (drawerTimerRef.current) {
  //       clearTimeout(drawerTimerRef.current);
  //     }
  //   };
  // }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [drawerScroll, setDrawerScroll] = useState<"hidden" | "auto">("hidden");
  const handleSidebarToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const [downloadAnchorEl, setDownloadAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const [downloadingReportId, setDownloadingReportId] = useState<string | null>(null);
  const isDownloadPopoverOpen = Boolean(downloadAnchorEl);

  const handleDownloadClick = (event: React.MouseEvent<HTMLElement>) => {
    setDownloadAnchorEl(event.currentTarget);
    fetchReportsData(); // Refresh reports when popover opens
  };

  const handleDownloadClose = () => {
    setDownloadAnchorEl(null);
  };

  const handleReportDownload = async (report: any) => {
    setDownloadingReportId(report.id);
    try {
      let response = null;
      if (report.status === "completed") {
        response = await axiosInstance.get(
          END_POINTS.DOWNLOAD_LINK_ENDPOINT,
          {
            params: {
              report_id: report.id, // Use the actual report ID from API
            },
          }
        );
      } else {
        response = await axiosInstance.put(
          END_POINTS.REPORT_DOWNLOAD,
          {

            report_id: report.id, // Use the actual report ID from API
          }

        );
      }

      if (response.status === 200 && response.data.download_url) {
        if (report.status == "failed") {
          setApiReportsData(prevData => {
            console.log("Current apiReportsData before update:", prevData);

            // Check if object with this id already exists
            const existingIndex = prevData.findIndex(item => item.id === report.id);

            if (existingIndex !== -1) {
              // Update existing object with all fields from transformedReportData
              const updatedData = [...prevData];
              updatedData[existingIndex] = {
                ...updatedData[existingIndex],
                status: "In progress"
              };
              console.log("Updated existing report in apiReportsData at index", existingIndex, ":", updatedData[existingIndex]);
              console.log("Updated apiReportsData array:", updatedData);
              return updatedData;
            }
            return prevData; // Return original data if no match found
          });
        }
        // Generate filename based on report name and current date
        const now = new Date();
        const dateStr = `${String(now.getMonth() + 1).padStart(2, "0")}${String(
          now.getDate()
        ).padStart(2, "0")}${now.getFullYear()}`;
        const fileName = `${report.custom_report_name.replace(
          /\s+/g,
          "_"
        )}-${dateStr}.pdf`;

        // Create download link using the URL from API response
        const link = document.createElement("a");
        link.href = response.data.download_url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);

        toast.success("Report downloaded successfully !");
      } else {
        toast.error("Failed to download the report.");
      }
    } catch (error: any) {
      console.error("Error downloading report:", error);
      toast.error("Failed to download report, please try again.");
    } finally {
      setDownloadingReportId(null);
      handleDownloadClose();
    }
  };

  useEffect(() => { }, [drawerScroll]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        bgcolor: theme.palette.background.default,
      }}
    >
      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          bgcolor: theme.palette.background.paper,
          height: "60px",
          zIndex: 1000,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pb: 0,
            color: theme.palette.text.primary,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              edge="start"
              onClick={() => setOpen(true)}
              sx={{
                mr: 2,
                color: theme.palette.text.primary,
                "&:focus": { outline: "none" },
              }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={theme.palette.mode === "dark" ? darklogo : LogoWhite}
              alt="logo"
              style={{ width: "100px", height: "35px", cursor: "pointer" }}
              onClick={() => navigate("/dashboard")}
            />
            <Divider
              orientation="vertical"
              flexItem
              sx={{ height: "35px", borderColor: "grey.400", mt: 0, pl: 2 }}
            />

            <div role="presentation" onClick={handleBreadcrumbClick}>
              {scheduleEdit ||
                scanDetails ||
                assetsDetails ||
                scanDetailsInformation ||
                showDiscoverySecurityDropdown ||
                showDiscoverySecurityTitle ||
                cloudDetails ||
                isConfigDiffFocused ? (
                <>
                  <>{scheduleEdit && renderScheduleDropdown()}</>
                  <>{(scanDetails || cloudDetails || showDiscoverySecurityDropdown) && renderScansDropdown()}</>
                  <>{showDiscoverySecurityTitle && renderDiscoverySecurityTitle()}</>
                  <>{assetsDetails && renderAssetsDropdown()}</>
                  <>{isConfigDiffFocused && renderConfigDiffDeviceDropdown()}</>
                  <>
                    {scanDetailsInformation && rendreScanDetailsInformtaion()}
                  </>
                </>
              ) : location.pathname.includes("compliance-dashboard") ? (
                type ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <ArrowBackIcon
                      sx={{ marginLeft: 3, cursor: "pointer" }}
                      onClick={() => navigate("/compliance-dashboard")}
                    />
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "20px",
                        marginLeft: 2,
                        color: "text.primary",
                      }}
                      variant="h6"
                      component="div"
                    >
                      {type}
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      marginLeft: 3,
                      color: "text.primary",
                    }}
                    variant="h6"
                    component="div"
                  >
                    Compliance
                  </Typography>
                )
              ) : (
                <>
                  <Breadcrumbs aria-label="breadcrumb">
                    {breadcrumbs.map((breadcrumb, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {breadcrumb.icon && (
                          <IconButton
                            onClick={breadcrumb.iconOnClick} // Handle icon click
                            sx={{
                              color: "inherit",
                              "&:hover": { backgroundColor: "transparent" },
                            }}
                          >
                            <breadcrumb.icon />
                          </IconButton>
                        )}
                        <Typography
                          sx={{ ...breadcrumb.style, color: "text.primary" }}
                          variant="h6"
                          component="div"
                        >
                          {breadcrumb.text}
                        </Typography>
                      </Box>
                    ))}
                  </Breadcrumbs>
                </>
              )}
            </div>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* <IconButton
              onClick={handleDownloadClick}
              sx={{ "&:focus": { outline: "none" } }}
              color="inherit"
            >
              <DownloadIcon />
            </IconButton> */}
            <IconButton
              sx={{
                "&:focus": { outline: "none" },
                position: "relative",
                width: 36,
                height: 36,
              }}
              onClick={handleDownloadClick}
            >
              <img
                src={DownloadIcon}
                alt="DownloadIcon"
                style={{
                  height: "20px",
                  filter: theme.palette.mode === "dark" ? "brightness(0) invert(1)" : "brightness(0) invert(0.2)"
                }}
              />
              {/* Red dot indicator */}
              {reportData !== null && reportData !== undefined && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    bgcolor: "error.main",
                    color: "white",
                    borderRadius: "50%",
                    minWidth: "12px",
                    height: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                    border: "1.5px solid white",
                    boxShadow: 1,
                    pointerEvents: "none",
                  }}
                >
                </Box>
              )}
            </IconButton>
            <Popover
              open={isDownloadPopoverOpen}
              anchorEl={downloadAnchorEl}
              onClose={handleDownloadClose} // closes on background click or Esc
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                sx: {
                  p: 2,
                  minWidth: 600,
                  maxWidth: 600,
                  maxHeight: 500,
                  borderRadius: 2,
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                },
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={2}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{
                    color: theme.palette.text.primary,
                  }}
                >
                  Generating Reports
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <IconButton
                    size="small"
                    onClick={fetchReportsData}
                    disabled={isLoadingReports}
                    sx={{
                      color: theme.palette.mode === "dark" ? "white" : theme.palette.primary.main,
                      "&:hover": {
                        backgroundColor: theme.palette.mode === "dark"
                          ? "rgba(255, 255, 255, 0.08)"
                          : "rgba(33, 150, 243, 0.1)"
                      },
                      "&:disabled": {
                        color: theme.palette.action.disabled,
                      },
                    }}
                  >
                    <RefreshIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <InfoIcon sx={{
                      fontSize: 18,
                      color: theme.palette.mode === "dark" ? "white" : theme.palette.primary.main
                    }} />
                    <Typography
                      variant="caption"
                      sx={{
                        color: theme.palette.text.secondary,
                        fontStyle: "italic"
                      }}
                    >
                      Reports expire in 2 hours after generation
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Table Header */}
              <Box
                display="flex"
                justifyContent="space-between"
                pb={1}
                mb={2}
                sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
              >
                {tableHeaders.map((header) => (
                  <Typography
                    key={header.key}
                    variant="caption"
                    sx={{
                      flex: header.flex,
                      textAlign: header.align || "left",
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                      fontSize: "12px",
                    }}
                  >
                    {header.label}
                  </Typography>
                ))}
              </Box>

              {/* Report Rows Container with Scroll */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  overflowX: "hidden",
                  maxHeight: "400px",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: theme.palette.mode === "dark" ? "#2D2D2D" : "#f1f1f1",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: theme.palette.mode === "dark" ? "#555" : "#bbb",
                    borderRadius: "3px",
                    "&:hover": {
                      background: theme.palette.mode === "dark" ? "#777" : "#999",
                    },
                  },
                }}
              >
                {isLoadingReports ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py={4}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.text.secondary,
                        fontSize: "14px",
                        fontStyle: "italic",
                      }}
                    >
                      Loading reports...
                    </Typography>
                  </Box>
                ) : apiReportsData.length > 0 ? (
                  sortReportsByCreatedAtDesc(apiReportsData).map((report, index, array) => (
                    <Box
                      key={report.id}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={index < array.length - 1 ? 2 : 0}
                      sx={{ py: 1 }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          flex: 2,
                          fontWeight: 500,
                          color: report.status === "failed" ? "#FA4B50" : theme.palette.text.primary,
                          fontSize: "14px",
                        }}
                      >
                        {`${report.custom_report_name} (${report.report})`}
                      </Typography>
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: report.status === "failed" ? "#FA4B50" : theme.palette.text.primary,
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "capitalize",
                          }}
                        >
                          {report.status}
                        </Typography>
                      </Box>
                      {/* <Typography
                        variant="body2"
                        sx={{
                          flex: 1,
                          textAlign: "center",
                          color: "#64748b",
                          fontSize: "13px",
                        }}
                      >
                        {report.timeToGenerate}
                      </Typography> */}
                      <Box sx={{ flex: 1, textAlign: "center" }}>
                        <Button
                          size="small"
                          variant="contained"
                          disabled={report.status !== "completed" || report.status === "failed"}
                          sx={{

                            bgcolor: report.status === "completed" ? theme.palette.primary.main :
                              report.status === "failed" ? "#FA4B50" : "transparent",
                            color: (report.status === "completed" || report.status === "failed") ? "white" : theme.palette.action.disabled,
                            textTransform: "none",
                            height: "30px",
                            fontSize: "12px",
                            "&:focus": { outline: "none" },
                            fontWeight: 500,
                            "&:disabled": {
                              backgroundColor: report.status === "failed" ? "#FA4B50" : "transparent",
                              color: report.status === "failed" ? "white" : theme.palette.action.disabled,
                            },
                            "&:hover": report.status === "completed" ? {
                              bgcolor: theme.palette.primary.dark,
                            } : report.status === "failed" ? {
                              bgcolor: "#FA4B50",
                            } : {},
                          }}
                          onClick={() => {
                            if (report.status === "completed") {
                              handleReportDownload(report);
                            }
                            if (report.status === "failed") {
                              handleReportDownload(report);
                            }
                          }}
                        >
                          {downloadingReportId === report.id ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CircularProgress size={16} sx={{ color: "white" }} />
                              <span>Downloading...</span>
                            </Box>
                          ) : (
                            report.status === "failed" ? "Try Again" : "Download"
                          )}
                        </Button>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py={4}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.text.secondary,
                        fontSize: "14px",
                        fontStyle: "italic",
                      }}
                    >
                      No data available
                    </Typography>
                  </Box>
                )}
              </Box>
            </Popover>
            <IconButton
              sx={{
                "&:focus": { outline: "none" },
                position: "relative",
                width: 36,
                height: 36,
              }}
              onClick={() => {
                eventEmitter.emit("closeAllDrawers");
                fetchNotificationCounts();
                setNotificationSidebarOpen(true);
              }}
            >
              <NotificationsIcon />
              {/* ALERT badge (red, top) */}
              {alertCount > 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    bgcolor: "error.main",
                    color: "white",
                    borderRadius: "50%",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                    border: "1.5px solid white",
                    boxShadow: 1,
                    pointerEvents: "none",
                  }}
                >
                  {alertCount}
                </Box>
              )}
              {/* NOTIFICATION badge (blue, bottom) */}
              {notificationCount > 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 16,
                    right: 0,
                    bgcolor: "primary.main",
                    color: "white",
                    borderRadius: "50%",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                    border: "1.5px solid white",
                    boxShadow: 1,
                    pointerEvents: "none",
                  }}
                >
                  {notificationCount}
                </Box>
              )}
            </IconButton>
            <SearchDialog />
            <IconButton
              onClick={toggleGlobalFilter}
              sx={{ "&:focus": { outline: "none" }, position: "relative" }}
            >
              <FilterAltIcon />
              {global_filter && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    width: 10,
                    height: 10,
                    bgcolor: "success.main",
                    borderRadius: "50%",
                    border: "2px solid white",
                    zIndex: 1,
                  }}
                />
              )}
            </IconButton>

            <IconButton
              onClick={handleMenuOpen}
              sx={{ "&:focus": { outline: "none", zIndex: 999 } }}
            >
              {profileImage ? (
                <Avatar src={profileImage} sx={{ width: 28, height: 28 }} />
              ) : (
                <Avatar sx={{ width: 28, height: 28 }}>
                  {/* {userDetail?.firstname && userDetail?.lastname
                    ? `${userDetail.firstname.charAt(0).toUpperCase()}${userDetail.lastname.charAt(0).toUpperCase()}`
                    : <PersonIcon sx={{ fontSize: 20 }} />
                  } */}
                </Avatar>
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              disableScrollLock={true}
              disablePortal={true}
              slotProps={{
                backdrop: {
                  invisible: true,
                },
              }}
              PaperProps={{
                sx: {
                  minWidth: 220,
                  mt: 1,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  "& .MuiMenuItem-root": {
                    py: 1.5,
                    px: 2,
                  },
                },
              }}
            >
              <Tooltip title={userDetails?.organization_email}>
                <Typography
                  sx={{
                    fontWeigt: "bolder",
                    fontSize: "15px",
                    mb: 1,
                    pt: 2,
                    pl: 2,
                  }}
                >
                  {userDetails?.organization_email?.length > 20
                    ? `${userDetails.organization_email.slice(0, 20)}...`
                    : userDetails?.organization_email}
                </Typography>
              </Tooltip>
              <MenuItem onClick={handleAccount}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2">Account</Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: "auto",
                        bgcolor: "primary.main",
                        color: "white",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: "0.75rem",
                      }}
                    >
                      {userDetails?.subscription_code
                        ? userDetails?.subscription_code
                          .toLowerCase()
                          .replace(/\b\w/g, (char: string) =>
                            char.toUpperCase()
                          )
                        : ""}
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{
                      fontSize: "0.75rem",
                    }}
                  >
                    Expires in {days} days
                  </Typography>
                </Box>
              </MenuItem>
              <MenuItem sx={{ py: 1 }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      bgcolor:
                        theme.palette.mode === "dark" ? "#2D2D2D" : "#F0F0FF",
                      p: 0.5,
                      borderRadius: 1,
                    }}
                  >
                    <Button
                      onClick={() => {
                        if (themeContext?.darkMode) {
                          themeContext.toggleTheme();
                          setMatchBrowser(false);
                        }
                        handleMenuClose();
                      }}
                      sx={{
                        flex: 1,
                        bgcolor: !themeContext?.darkMode
                          ? "primary.main"
                          : "transparent",
                        color: !themeContext?.darkMode
                          ? "white"
                          : theme.palette.mode === "dark"
                            ? "#fff"
                            : "#696595",
                        "&:hover": {
                          bgcolor: !themeContext?.darkMode
                            ? "primary.dark"
                            : theme.palette.mode === "dark"
                              ? "rgba(255, 255, 255, 0.08)"
                              : "rgba(0, 0, 0, 0.04)",
                        },
                        textTransform: "none",
                        py: 0.5,
                      }}
                      startIcon={<LightModeIcon />}
                    >
                      Light
                    </Button>
                    <Button
                      onClick={() => {
                        if (!themeContext?.darkMode) {
                          themeContext?.toggleTheme();
                          setMatchBrowser(false);
                        }
                        handleMenuClose();
                      }}
                      sx={{
                        flex: 1,
                        bgcolor: themeContext?.darkMode
                          ? "primary.main"
                          : "transparent",
                        color: themeContext?.darkMode
                          ? "white"
                          : theme.palette.mode === "dark"
                            ? "#fff"
                            : "#696595",
                        "&:hover": {
                          bgcolor: themeContext?.darkMode
                            ? "primary.dark"
                            : theme.palette.mode === "dark"
                              ? "rgba(255, 255, 255, 0.08)"
                              : "rgba(0, 0, 0, 0.04)",
                        },
                        textTransform: "none",
                        py: 0.5,
                      }}
                      startIcon={<DarkModeIcon />}
                    >
                      Dark
                    </Button>
                  </Box>
                  <Divider />
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={matchBrowser}
                        onChange={(e) => {
                          setMatchBrowser(e.target.checked);
                          if (e.target.checked) {
                            const prefersDark = window.matchMedia(
                              "(prefers-color-scheme: dark)"
                            ).matches;
                            if (prefersDark !== themeContext?.darkMode) {
                              themeContext?.toggleTheme();
                            }
                          }
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.75rem",
                          color:
                            theme.palette.mode === "dark"
                              ? "#a0a0a0"
                              : "#696595",
                        }}
                      >
                        Match Browser
                      </Typography>
                    }
                    sx={{
                      m: 0,
                    }}
                  />
                </Box>
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <Typography variant="body2">Sign Out</Typography>
              </MenuItem>
            </Menu>

            {hasPermissions(ROLES_ROUTE.NEW_SCAN) && isAssetInventory() !== 1 && (
              <Button
                variant="contained"
                sx={{
                  bgcolor: theme.palette.primary.main,
                  color: "white",
                  textTransform: "none",
                  height: "30px",
                  fontSize: "12px",
                  "&:focus": { outline: "none" },
                }}
                onClick={() => navigate("/on-premises/new-newscan")}
              >
                New Scan
              </Button>
            )}


          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            height: "100vh", // Always use 100vh for consistent layout
            boxSizing: "border-box",
            position: "fixed",
            top: 0,
            zIndex: 1201,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            overflowX: "hidden",
            overflowY: drawerScroll,
            bgcolor: theme.palette.background.paper,
          },
          "& .MuiBackdrop-root": {
            backdropFilter: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            pr: 1,
            pt: 1.5,
            pb: 0,
            pl: 1,
            position: "relative",
            zIndex: 1500,
            bgcolor: theme.palette.background.paper,
          }}
        >
          <IconButton
            onClick={toggleDrawer}
            sx={{ color: theme.palette.text.primary, mr: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={theme.palette.mode === "dark" ? darklogo : LogoWhite}
            alt="logo"
            style={{ width: "100px", height: "35px", cursor: "pointer" }}
            onClick={() => navigate("/dashboard")}
          />
        </Box>
        <Divider
          orientation="horizontal"
          sx={{
            width: "100%",
            borderColor: "grey.400",
            zIndex: 2000,
            pt: 1,
            m: 0,
          }}
        />
        <Box
          sx={{
            flex: 1,
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            minHeight: 0, // Ensures flexbox child can shrink/grow without layout jump
          }}
          className="scroll"
        >
          <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setOpen(false)} />
        </Box>
      </Drawer>
      {/* global filter  start */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={openGlbFilter}
        onClose={toggleGlobalFilter}
        sx={{
          "& .MuiDrawer-paper": {
            width: globalFilterWidth,
            height: "100vh",
            boxSizing: "border-box",
            position: "fixed",
            top: 0,
            zIndex: 1201,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            overflow: "hidden",
            boxShadow:
              theme.palette.mode === "dark"
                ? "-4px 0 15px rgba(0, 0, 0, 0.3)"
                : "-4px 0 15px rgba(0, 0, 0, 0.1)",
          },
          "& .MuiBackdrop-root": {
            backdropFilter: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <GlobalFilter
          setIsLoader={setIsLoader}
          toggleGlobalFilter={toggleGlobalFilter}
        />
      </Drawer>
      <Loading show={isLoader} />
      {/* Global filter end */}
      <NotificationSidebar
        open={notificationSidebarOpen}
        onClose={() => setNotificationSidebarOpen(false)}
        themeMode={theme.palette.mode === "dark" ? "dark" : "light"}
        fetchNotificationCounts={fetchNotificationCounts}
        initialTab={notificationSidebarTab}
        openRequest={notificationSidebarRequest}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: "55px",
          height: "calc(100vh - 55px)",
          overflow: "auto",
          bgcolor:
            theme.palette.mode === "dark" ? "background.default" : "#fbfbff",
          "&::-webkit-scrollbar": {
            width: "0px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#bbb",
            borderRadius: "3px",
            "&:hover": {
              background: "#999",
            },
          },
        }}
      >
        {children}
      </Box>

      <Drawer
        variant="temporary"
        anchor="right"
        open={isActionClicked}
        onClose={() => setIsActionClicked(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 400,
            height: "100vh",
            boxSizing: "border-box",
            position: "fixed",
            top: 0,
            zIndex: 1300,
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            bgcolor: theme.palette.background.paper,
          },
          "& .MuiBackdrop-root": {
            backdropFilter: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "20px",
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: "18px" }}
          >
            Account
          </Typography>
          <CancelIcon
            onClick={() => setIsActionClicked(false)}
            fontSize="medium"
            sx={{ cursor: "pointer" }}
          />
        </Box>

        <Accounts />
      </Drawer>
    </Box>
  );
};

export default AppLayout;
